import { ref } from 'vue';

const settingsDrawerOpen = ref(false);

/** Hub-wide settings drawer — DualPane gear opens this from welcome and every sub-app. */
export function useHubSettingsDrawer() {
	function openSettingsDrawer(): void {
		settingsDrawerOpen.value = true;
	}

	function closeSettingsDrawer(): void {
		settingsDrawerOpen.value = false;
	}

	return {
		settingsDrawerOpen,
		openSettingsDrawer,
		closeSettingsDrawer,
	};
}
